import './password-input.css';
import eyeOpened from '../../imgs/eye-opened.png';
import eyeClosed from '../../imgs/eye-closed.png';
import whiteEyeOpened from '../../imgs/white-eye-opened.png';
import whiteEyeClosed from '../../imgs/white-eye-closed.png';
import { useState, useEffect } from 'react';
import { useTheme } from '../../ThemeContext';
import { THEMES } from '../../constants/theme';

function PasswordInput({
    id,
    name,
    className = '',
    value,
    disabled,
    onChange,
    onValidate,
    warningMsg,
    shouldValidate,
    maxLength,
    placeholder = 'Palavra-passe',
    autoComplete = 'off'
}) {
    const { resolvedTheme } = useTheme();
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [invalidValue, setInvalidValue] = useState(false);

    const useWhiteThemeIcons = resolvedTheme === THEMES.DARK;
    const passIcon = isPasswordVisible
        ? (useWhiteThemeIcons ? whiteEyeClosed : eyeClosed)
        : (useWhiteThemeIcons ? whiteEyeOpened : eyeOpened);
    const passType = isPasswordVisible ? 'text' : 'password';

    useEffect(() => {
        if (shouldValidate)
            setInvalidValue(!onValidate());
    }, [shouldValidate, onValidate]);

    function handlePassIcon() {
        if (disabled)
            return;

        setIsPasswordVisible((prevState) => !prevState);
    }

    return (
        <div className='password-container'>
            <div className="password-input">
                <input
                    id={id}
                    name={name}
                    className={className}
                    type={passType}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    value={value}
                    disabled={disabled}
                    onChange={(e) => {
                        setInvalidValue(false);
                        onChange(e);
                    }}
                    onBlur={() => setInvalidValue(!onValidate())}
                    maxLength={maxLength}
                />
                <img src={passIcon} alt='eye-opened' onClick={handlePassIcon} />
            </div>

            <span className={`password-warning-msg ${invalidValue ? 'show' : ''}`}>
                {warningMsg}
            </span>
        </div>
    );
}

export default PasswordInput;